module.exports = __webpack_public_path__ + "static/popup_mps-478f600fded2800761442cb1b0bf7695.jpg";